import { AppIcon, isStandardTrack, TrackCode } from '@backrs_ui/common-ui';

import { TRACK_IMAGES } from '@backrs_ui/grow-ui/src/assets/careerTrackImages';

import { Box, SxProps, Theme } from '@mui/material';

type CareerTrackIllustrationProps = Readonly<{
  trackCode: TrackCode;
  alt: string;
}>;

export function CareerTrackIllustration({ trackCode, alt }: CareerTrackIllustrationProps) {
  if (!isStandardTrack(trackCode)) {
    return null;
  }

  const trackImage = TRACK_IMAGES[trackCode];

  return (
    <Box sx={containerSx}>
      <Box sx={iconSx} aria-hidden>
        <AppIcon iconName="Route" diameter="20px" color="Colors/Base/White" />
      </Box>
      <Box component="img" src={trackImage} alt={alt} sx={imgSx} />
    </Box>
  );
}

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'relative',
  width: '100%',
  borderRadius: backrs.radius['radius-xl'],
  border: `1px solid ${backrs.colors['Colors/Foreground/fg-quinary-hover']}`,
  boxShadow: backrs.shadows['shadow-xs'],
  padding: backrs.spacing['spacing-2xl'],
  boxSizing: 'border-box',
  bgcolor: backrs.colors['Colors/Base/White'],
});

const iconSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'absolute',
  top: backrs.spacing['spacing-2xl'],
  left: backrs.spacing['spacing-2xl'],
  width: '40px',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: backrs.radius['radius-md'],
  backgroundColor: backrs.colors['Brand/500'],
  border: `2px solid ${backrs.colors['Colors/Foreground/fg-quaternary-hover']}`,
  boxSizing: 'border-box',
});

const imgSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'block',
  width: '85%',
  maxWidth: '486px',
  height: 'auto',
  marginInline: 'auto',
  mt: `calc(${backrs.spacing['spacing-4xl']} + ${backrs.spacing['spacing-3xl']})`,
  mb: backrs.spacing['spacing-2xl'],
});
